export enum UserRoleType {
    ADMIN = 'admin',
    DOCTOR = 'doctor',
    FORTAT = 'fortat',
    LAB = 'lab',
    PACIENT = 'pacient',
    INVOICE = 'invoice',
}

export type UserFirstLastName = {
    first_name: string;
    last_name: string;
};
